import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<File | string>;

export const AddFile: HandlerType = props => {
    if (!props.parameter) {
        return;
    }
    props.dispatch({
        type: "Custom/OrderFileUpload/AddFile",
        file: props.parameter as any,
    } as any);
};

export const ClearFiles: HandlerType = props => {
    if (props.parameter) {
        return;
    }
    props.dispatch({
        type: "Custom/OrderFileUpload/ClearFiles",
    } as any);
};

export const chain = [AddFile, ClearFiles];
const setOrderFileUpload = createHandlerChainRunner(chain, "OrderFileUpload");
export default setOrderFileUpload;
